import { currencyDisplay, formatMoneyFull } from "@/lib/money"

/**
 * "1 USD = ₫25,999": the rate between two currencies, written with the
 * stronger one (fewer units per USD) as the "1" side so it reads the same
 * whichever of the two is the display currency.
 */
export function rateLine(a: string, b: string, rates: Record<string, number>): string | null {
  if (a === b || !(a in rates) || !(b in rates)) return null
  const [strong, weak] = rates[a] <= rates[b] ? [a, b] : [b, a]
  const perUnit = rates[weak] / rates[strong]
  return `1 ${strong} = ${currencyDisplay(weak).symbol}${formatMoneyFull(perUnit, weak)}`
}

/** One line per currency on the page other than the display currency. */
export function rateLines(displayCurrency: string | null, currencies: string[], rates: Record<string, number>): string[] {
  if (!displayCurrency) return []
  return currencies.map((c) => rateLine(displayCurrency, c, rates)).filter((l): l is string => l !== null)
}
